import { useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { useCommanKit } from "./useCommanKit";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { dateConvert } from "../../../utils/Helper";
import { useMultiStepForm } from "./useMultiStepForm";


export const useStationHouse = ({ data }) => {

    const { showSuccess, showError } = useContext(ToastContext);
    const { getEmployeeDetails } = useCommanKit({ data });
    const [inputValue, setInputValue] = useState({});
    const [inputErrors, setInputErrors] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [submitStatusId, setSubmitStatusId] = useState(null);
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
    const pdfContentRef = useRef()
    const { steps, formData } = useMultiStepForm()

    const inputFields = [
        {
            name: 'station_house_father_name',
            label: "Please enter father name",
            type: 'text',
            required: true,
        },
        {
            name: 'residence_place',
            label: "Please enter residing place",
            type: 'text',
            required: true,
        },
        {
            name: 'residence_year',
            label: "Please enter residing years",
            type: 'number',
            required: true,
        },
    ];

    useEffect(() => {
        data?.employee?.user_code && getEmployeeDetails("user_station_house_details", data?.employee?.user_code).then((res) => {
            setInputValue(res?.user_station_house_details[0])
            setSubmitStatusId(res?.user_station_house_details?.[0]?.submit_status_id || null)
        }).catch((error) => {
            console.error(error)
        })
    }, [data])



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputValue((prev) => ({ ...prev, [name]: value }));
    };


    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const requiredFields = _.pluck(inputFields, "name")
            const errors = {};
            requiredFields.forEach(field => {
                if (!inputValue?.[field] || inputValue[field].toString().trim() === '') {
                    errors[field] = `${field.replace(/_/g, ' ')} is required`;
                }
            });
            inputValue.residence_year = Number(inputValue?.residence_year);
            Number(inputValue?.residence_year)
            if (inputValue?.residence_year && (isNaN(inputValue.residence_year) || inputValue.residence_year <= 0)) {
                errors.residence_year = "Residing years must be a valid positive number";
            }
            setInputErrors(errors);
            if (Object.keys(errors).length > 0) {
                return;
            }
            delete inputValue?.submit_status_id
            delete inputValue?.user_code

            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEESTATIONHOUSEDETAILS"), inputValue)
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error(error)
        }
    }

    const welcomekitsubmit = async () => {
        try {
            const pdfData = await downloadAllStepsPDF(true)
            const payload = {
                submit_status_id: submitStatusId || 0,
                is_submit: true,
                "welcomekit_filename": data?.employee?.employee_id,
                "base64_string": pdfData?.split(",")?.[1] || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEEWELCOMKITSUBMIT"), payload);
            if (!res?.body?.error_status) {
                showSuccess('Success', res.body.message);
                setShowPopup(false)
            } else {
                showError("Error", res.body?.errorMessage);
                setShowPopup(false)
            }
        } catch (error) {
            setShowPopup(false)
            console.error(error)
            setIsGeneratingPDF(false);
        }
    };

    const downloadAllStepsPDF = async (returnBase64 = false) => {
        setIsGeneratingPDF(true);

        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'pt',
            format: 'a4',
            compress: true,
        });
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const margin = 20;
        const contentWidth = pdfWidth - (margin * 2);
        let currentY = margin + 15;

        pdf.setFontSize(24);
        pdf.setFont(undefined, 'bold');
        pdf.text('Employee Welcome Kit', pdfWidth / 2, currentY + 25, { align: 'center' });
        pdf.setFontSize(18);
        pdf.setFont(undefined, 'normal');
        const employeeName = data?.employee?.user_display_name || 'Employee';
        pdf.text(employeeName, pdfWidth / 2, currentY + 65, { align: 'center' });
        pdf.setFontSize(12);
        pdf.setFont(undefined, 'normal');
        const employeeId = data?.employee?.employee_id || 'N/A';
        pdf.text(`Employee ID: ${employeeId}`, pdfWidth / 2, currentY + 95, { align: 'center' });
        const joiningDate = data?.employee?.joining_date || 'N/A';
        pdf.text(`Joining Date: ${dateConvert(joiningDate, "day-mon-year")}`, pdfWidth / 2, currentY + 115, { align: 'center' });

        pdf.addPage();
        currentY = margin + 10;

        for (let i = 0; i < steps.length; i++) {
            const stepElements = pdfContentRef?.current?.querySelectorAll('div[style*="border: 1px"]');
            const stepElement = stepElements?.[i];
            if (!stepElement) {
                continue;
            }

            const originalLeft = stepElement.style.left;
            stepElement.style.position = 'relative';
            stepElement.style.left = '0';
            stepElement.style.visibility = 'visible';

            const canvas = await html2canvas(stepElement, {
                scale: 1.2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                width: 714,
                height: stepElement.scrollHeight,
                logging: false
            });
            stepElement.style.left = originalLeft;

            const imgData = canvas.toDataURL('image/png', 0.85);
            const imgProps = pdf.getImageProperties(imgData);
            const fullImgHeight = (imgProps.height * contentWidth) / imgProps.width;
            const maxPageHeight = pdfHeight - (margin * 2) - 10;
            let remainingHeight = fullImgHeight;
            let sourceY = 0;

            while (remainingHeight > 0) {
                if (currentY > margin + 10) {
                    pdf.addPage();
                    currentY = margin + 10;
                }
                const spaceLeft = maxPageHeight - (currentY - margin - 10);
                const fragmentHeight = Math.min(remainingHeight, spaceLeft);
                const fragmentHeightPx = (fragmentHeight / fullImgHeight) * canvas.height;

                const fragmentCanvas = document.createElement('canvas');
                fragmentCanvas.width = canvas.width;
                fragmentCanvas.height = fragmentHeightPx;
                const ctx = fragmentCanvas.getContext('2d');
                ctx.drawImage(canvas, 0, sourceY, canvas.width, fragmentHeightPx, 0, 0, canvas.width, fragmentHeightPx);

                const fragmentData = fragmentCanvas.toDataURL('image/png', 0.85);
                const fragmentPdfHeight = fragmentHeight;
                const fragmentPdfWidth = contentWidth;

                pdf.addImage(fragmentData, 'PNG', margin, currentY, fragmentPdfWidth, fragmentPdfHeight);
                currentY += fragmentPdfHeight;
                sourceY += fragmentHeightPx;
                remainingHeight -= fragmentHeight;
            }
        }

        setIsGeneratingPDF(false);
        if (returnBase64) {
            const base64PDF = pdf.output('datauristring');
            return base64PDF;
        } else {
            pdf.save(`welcome-kit-${data?.employee?.user_display_name || 'employee'}-${steps.length}-steps.pdf`);
            return null;
        }
    };


    return useMemo(() => ({
        inputValue, handleInputChange, handleSubmit, inputFields, inputErrors, showPopup, setShowPopup, welcomekitsubmit, isGeneratingPDF, pdfContentRef, steps, formData
    }), [, inputValue, handleInputChange, handleSubmit, inputFields, inputErrors, showPopup, setShowPopup, welcomekitsubmit, isGeneratingPDF, pdfContentRef, steps, formData])
}